import { EGeneralSearchFeatureType } from '@/types/search';
import DietInjectionFeatureSnippet from './DietInjectionFeatureSnippet';
import EmergencyContraceptiveFeatureSnippet from './EmergencyContraceptiveFeatureSnippet';
import FindPharmacyFeatureSnippet from './FindPharmacyFeatureSnippet';

interface Props {
  features?: Array<EGeneralSearchFeatureType>;
  navigateToFindPharmacyScreen: () => void;
  navigateDietInjectionScreen: () => void;
  navigateToEmergencyContraceptiveScreen: () => void;
}

const FeatureByKeyword = ({
  features,
  navigateToFindPharmacyScreen,
  navigateDietInjectionScreen,
  navigateToEmergencyContraceptiveScreen,
}: Props) => {
  if (!features) return null;
  return (
    <div className={'border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_24px_24px]'}>
      <div className={'typography-ui-13m mb-[12px] text-gray-500'}>연관 기능</div>
      <div>
        {features.map((feature) => {
          switch (feature) {
            case EGeneralSearchFeatureType.FindPharmacy:
              return (
                <FindPharmacyFeatureSnippet navigateToFindPharmacyScreen={navigateToFindPharmacyScreen} key={feature} />
              );
            case EGeneralSearchFeatureType.EmergencyContraceptive:
              return (
                <EmergencyContraceptiveFeatureSnippet
                  navigateToEmergencyContraceptiveScreen={navigateToEmergencyContraceptiveScreen}
                  key={feature}
                />
              );
            case EGeneralSearchFeatureType.DietInjection:
              return (
                <DietInjectionFeatureSnippet navigateDietInjectionScreen={navigateDietInjectionScreen} key={feature} />
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

export default FeatureByKeyword;
